// Site geneli içerik — ana sayfa (kısa SEO şeridi) ve Nasıl Çalışır sayfası
// aynı kaynaktan beslenir.

export const SERVICES = [
  {
    name: 'Ücretsiz ATS uyumlu CV oluşturma',
    description:
      'Yapay zeka destekli CV asistanı ile dakikalar içinde profesyonel, ATS (aday takip sistemi) uyumlu özgeçmiş hazırlayın. Mevcut CV\'nizi yükleyip otomatik düzenletebilirsiniz. Ücretsizdir.',
  },
  {
    name: 'Yapay zeka ile akıllı ilan eşleştirme ve form taslağı hazırlama',
    description:
      'Siz uyurken bile yapay zeka iş ilanlarını tarar ve profilinize en uygun olanları bulur. Onay verdiğiniz ilanlar için form taslağını yazılım hazırlar; gönderim yalnızca sizin onayınızla gerçekleşir. Tüm işlemleri tek ekrandan takip edersiniz.',
  },
  {
    name: 'İlan uyum ve ATS analizi',
    description:
      'İş ilanı bağlantısını yapıştırın; CV\'nizin o pozisyona uygunluğunu, ATS uyumunu ve eksik anahtar kelimeleri görün.',
  },
  {
    name: 'Uzaktan (remote) ve yurt dışı iş fırsatları',
    description:
      'Türkiye\'de yaşarken yurt dışındaki şirketlere uzaktan çalışabileceğiniz pozisyonları bulun, döviz bazlı gelir imkânlarını değerlendirin.',
    areaServed: 'Worldwide',
  },
  {
    name: 'Yabancı dil engelini kaldıran toplantı çevirmeni',
    description:
      'TransMeet masaüstü uygulaması toplantılarınızı anlık çevirir. Yurt dışı mülakatlarına ve uluslararası ekiplerle çalışmaya dil bariyeri olmadan katılırsınız.',
    areaServed: 'Worldwide',
  },
  {
    name: 'ABD ve Kanada çalışma yolu değerlendirmesi',
    description:
      'ABD ve Kanada\'da çalışmak isteyen adaylar için vize uygunluğu, mesleki denklik ve kültürel uyum değerlendirmesi sunulur.',
    areaServed: ['US', 'CA'],
  },
];

export const FAQ = [
  {
    question: 'isBulsun.com ücretsiz mi?',
    answer:
      'Evet. CV oluşturma, ilan arama, ilan uyum analizi ve aylık belirli sayıda form taslağı hazırlama ücretsiz paketle kullanılabilir. Daha yüksek kullanım limiti isteyenler için aylık abonelik paketleri vardır.',
  },
  {
    question: 'ATS uyumlu CV nasıl oluşturulur?',
    answer:
      'Üye olduktan sonra CV asistanına bilgilerinizi yazmanız veya mevcut CV dosyanızı yüklemeniz yeterli. Yapay zeka özgeçmişinizi aday takip sistemlerinin (ATS) okuyabildiği düzende hazırlar ve eksik anahtar kelimeleri size bildirir.',
  },
  {
    question: 'Yapay zeka benim için ilanları tarayıp eşleştirebilir mi?',
    answer:
      'Evet. Siz uyurken bile yapay zeka asistanınız iş ilanlarını tarar ve profilinize yüksek uyum gösterenleri bulur. Dijital Temsil ve Otomasyon Açık Rıza Onayı ile onay verdiğinizde, bu ilanlar için form taslağını da yazılım hazırlar; gönderim yalnızca sizin onayınızla olur. isBulsun.com bir işe yerleştirme garantisi veya iş bulma/aracılık hizmeti değil, Veri Analiz ve Form Taslak Hazırlama Yazılımı lisansıdır; onayınızı dilediğiniz zaman geri alabilirsiniz.',
  },
  {
    question: 'Yabancı dilim yok, yurt dışında uzaktan çalışabilir miyim?',
    answer:
      'TransMeet uygulaması toplantılarınızı anlık olarak çevirir; böylece yabancı dil seviyeniz sınırlı olsa da uluslararası ekiplerle görüşme yapabilir ve uzaktan çalışabilirsiniz.',
  },
  {
    question: 'ABD veya Kanada\'da çalışmak için ne yapmalıyım?',
    answer:
      'isBulsun.com, ABD ve Kanada için vize uygunluğunuzu, mesleki denkliğinizi ve kültürel uyumunuzu değerlendirir; eksiklerinizi ve izlemeniz gereken adımları önceden gösterir. Vize başvurusu resmî makamlarca sonuçlandırılır.',
  },
  {
    question: 'Uzaktan çalışarak döviz kazanabilir miyim?',
    answer:
      'Uzaktan çalışmaya açık pozisyonlarda yurt dışındaki şirketler için çalışıp ücretinizi döviz olarak alabilirsiniz. Platform bu tür ilanları filtrelemenize yardımcı olur.',
  },
];
